import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function AdminSettings() {
  const [company, setCompany] = useState({ ad: "", adres: "", telefon: "", email: "", kurulus: "" });
  const [defaults, setDefaults] = useState({ gecerlilik: "", odeme_sekli: "", teslim_suresi: "", sevkiyat_yontemi: "", sartlar: "", USD_TRY: "", EUR_TRY: "" });
  const [content, setContent] = useState({ hakkimizda: "", "tedarik-sureci": "", iletisim: "" });

  useEffect(() => {
    api.get("/admin/settings").then((r) => {
      if (r.data.company) setCompany((c) => ({ ...c, ...r.data.company }));
      if (r.data.quote_defaults) setDefaults((d) => ({ ...d, ...r.data.quote_defaults }));
    });
    ["hakkimizda", "tedarik-sureci", "iletisim"].forEach((slug) =>
      api.get(`/content/${slug}`).then((r) => setContent((c) => ({ ...c, [slug]: r.data.icerik || "" }))));
  }, []);

  const saveCompany = async () => {
    await api.put("/admin/settings/company", company);
    toast.success("Firma bilgileri kaydedildi");
  };
  const saveDefaults = async () => {
    await api.put("/admin/settings/quote_defaults", {
      ...defaults,
      USD_TRY: defaults.USD_TRY === "" ? null : parseFloat(defaults.USD_TRY),
      EUR_TRY: defaults.EUR_TRY === "" ? null : parseFloat(defaults.EUR_TRY),
    });
    toast.success("Teklif varsayılanları kaydedildi");
  };
  const apiSaveContent = async (slug, baslik, icerik) => {
    await api.put(`/admin/content/${slug}`, { baslik, icerik });
  };

  return (
    <div className="max-w-3xl">
      <h1 className="font-head text-2xl font-bold text-slate-900 mb-6">Ayarlar</h1>

      <section className="bg-white border rounded-xl p-5 mb-6">
        <h2 className="font-head font-semibold text-slate-900 mb-4">Firma Bilgileri</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Firma Adı</Label><Input value={company.ad} onChange={(e) => setCompany({ ...company, ad: e.target.value })} className="mt-1.5" data-testid="set-firma-ad" /></div>
          <div><Label>Telefon</Label><Input value={company.telefon} onChange={(e) => setCompany({ ...company, telefon: e.target.value })} className="mt-1.5" data-testid="set-firma-tel" /></div>
          <div><Label>E-posta</Label><Input value={company.email} onChange={(e) => setCompany({ ...company, email: e.target.value })} className="mt-1.5" data-testid="set-firma-email" /></div>
          <div><Label>Kuruluş Yılı</Label><Input value={company.kurulus} onChange={(e) => setCompany({ ...company, kurulus: e.target.value })} className="mt-1.5" /></div>
        </div>
        <div className="mt-4"><Label>Adres</Label><Textarea value={company.adres} onChange={(e) => setCompany({ ...company, adres: e.target.value })} className="mt-1.5" data-testid="set-firma-adres" /></div>
        <Button onClick={saveCompany} className="mt-4 bg-teal-600 hover:bg-teal-700" data-testid="save-company-btn">Kaydet</Button>
      </section>

      <section className="bg-white border rounded-xl p-5 mb-6">
        <h2 className="font-head font-semibold text-slate-900 mb-4">Teklif Varsayılanları & Kurlar</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>USD/TL (varsayılan)</Label><Input type="number" value={defaults.USD_TRY ?? ""} onChange={(e) => setDefaults({ ...defaults, USD_TRY: e.target.value })} className="mt-1.5" data-testid="set-usd" /></div>
          <div><Label>EUR/TL (varsayılan)</Label><Input type="number" value={defaults.EUR_TRY ?? ""} onChange={(e) => setDefaults({ ...defaults, EUR_TRY: e.target.value })} className="mt-1.5" data-testid="set-eur" /></div>
          <div><Label>Geçerlilik</Label><Input value={defaults.gecerlilik} onChange={(e) => setDefaults({ ...defaults, gecerlilik: e.target.value })} className="mt-1.5" /></div>
          <div><Label>Ödeme Şekli</Label><Input value={defaults.odeme_sekli} onChange={(e) => setDefaults({ ...defaults, odeme_sekli: e.target.value })} className="mt-1.5" /></div>
          <div><Label>Teslim Süresi</Label><Input value={defaults.teslim_suresi} onChange={(e) => setDefaults({ ...defaults, teslim_suresi: e.target.value })} className="mt-1.5" /></div>
          <div><Label>Sevkiyat Yöntemi</Label><Input value={defaults.sevkiyat_yontemi} onChange={(e) => setDefaults({ ...defaults, sevkiyat_yontemi: e.target.value })} className="mt-1.5" /></div>
        </div>
        <div className="mt-4"><Label>Satış/Teklif Şartları</Label><Textarea value={defaults.sartlar} onChange={(e) => setDefaults({ ...defaults, sartlar: e.target.value })} className="mt-1.5" /></div>
        <p className="text-xs text-slate-400 mt-2">Not: Otomatik döviz kuru bağlantısı yoktur; kurlar manuel girilir ve teklif bazında değiştirilebilir.</p>
        <Button onClick={saveDefaults} className="mt-4 bg-teal-600 hover:bg-teal-700" data-testid="save-defaults-btn">Kaydet</Button>
      </section>

      <section className="bg-white border rounded-xl p-5">
        <h2 className="font-head font-semibold text-slate-900 mb-4">Kurumsal İçerik Metinleri</h2>
        {[["hakkimizda", "Hakkımızda"], ["tedarik-sureci", "Tedarik Süreci"], ["iletisim", "İletişim"]].map(([slug, title]) => (
          <div key={slug} className="mb-5">
            <Label>{title}</Label>
            <Textarea value={content[slug]} onChange={(e) => setContent({ ...content, [slug]: e.target.value })} className="mt-1.5 min-h-[100px]" data-testid={`content-${slug}`} />
            <Button size="sm" variant="outline" className="mt-2" onClick={() => apiSaveContent(slug, title, content[slug]).then(() => toast.success("Kaydedildi"))} data-testid={`save-content-${slug}`}>Kaydet</Button>
          </div>
        ))}
      </section>
    </div>
  );
}
